export default {
  filters: {
    managers: {
      placeholder: 'Sales managers',
    },
  },
  metrics: {
    collected_commission: 'Total Commission',
  },
  fields: {
    manager: 'Manager',
    area: 'Location',
    total_amount: 'Earnings',
    companies_live: 'Live',
    restaurant: 'Restaurant',
    live_from: 'Live from',
    plan_amount: 'Plan amount',
    prepayment_bonus_amount: 'Prepayment bonus',
    lead_source_bonus_amount: 'Lead source bonus',
    google_business_bonus_amount: 'Google business connection bonus',
    promo_code_bonus_amount: 'Master promo code bonus',
    smart_pricing_bonus_amount: 'Smart pricing bonus',
    mobile_app_bonus_amount: 'Mobile app bonus',
    sales_goal_bonus_amount: 'Sales goal bonus',
  },
  buttons: {
    export: 'Export',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
  },
};
